<!--<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">-->

<div class="page-container custom-page-background position-absolute">
  <div class="forgot-password-page">

    <form #f="ngForm" (submit)="formSubmit(f)" class="forgot-password-form">
      <div class="forgot-password-form-container">
        <div class="header">
          <div class="hass-logo" style=" max-width: 270px; margin: 0 auto;">
            <img src="/src/assets/images/HASSLogo.png" />
          </div>

          <p>where <strong>excellent hearing</strong> begins</p>
        </div>

        <div class="sub-header">
          <h2>Password Change</h2>
          <p>Enter new password</p>
        </div>


        <div class="form">
          <div class="form-group">
            <label>Password</label>
            <input type="password"
                   class="form-control form-control-lg"
                   [(ngModel)]="newPassword"
                   #pass="ngModel"
                   id="pass"
                   name="pass"
                   required
                   (ngModelChange)="validatePasswordStrength(newPassword)" />
            <div *ngIf="submitted && pass.invalid" class="invalid-feedback column">
              <div *ngIf="pass.errors?.['required']" class="row align-center gap-10 nowrap">
                <i class="fas fa-exclamation-circle"></i>
                <p>Password is required</p>
              </div>
            </div>
            <div *ngIf="submitted && !pass.invalid" class="invalid-feedback column">
              <div class="row align-center gap-10 nowrap"
                   [class.valid]="passwordValidations.minLength"
                    *ngIf="submitted && !passwordValidations.minLength">
                <i class="fas" [class.fa-check-circle]="passwordValidations.minLength"
                   [class.fa-exclamation-circle]="!passwordValidations.minLength"></i>
                <p>Password must be at least 8 characters long</p>
              </div>
              <div class="row align-center gap-10 nowrap"
                   [class.valid]="passwordValidations.uppercase"
                    *ngIf="submitted && !passwordValidations.uppercase">
                <i class="fas" [class.fa-check-circle]="passwordValidations.uppercase"
                   [class.fa-exclamation-circle]="!passwordValidations.uppercase"></i>
                <p>Password must contain an uppercase character</p>
                
              </div>
              <div class="row align-center gap-10 nowrap"
                   [class.valid]="passwordValidations.lowercase"
                    *ngIf="submitted && !passwordValidations.lowercase">
                <i class="fas" [class.fa-check-circle]="passwordValidations.lowercase"
                   [class.fa-exclamation-circle]="!passwordValidations.lowercase"></i>
                <p>Password must contain a lowercase character</p>
              </div>
              <div class="row align-center gap-10 nowrap"
                   [class.valid]="passwordValidations.number"
                    *ngIf="submitted && !passwordValidations.number">
                <i class="fas" [class.fa-check-circle]="passwordValidations.number"
                   [class.fa-exclamation-circle]="!passwordValidations.number"></i>
                <p>Password must contain a number</p>
              </div>
              <div class="row align-center gap-10 nowrap"
                   [class.valid]="passwordValidations.specialChar"
                    *ngIf="submitted && !passwordValidations.specialChar">
                <i class="fas" [class.fa-check-circle]="passwordValidations.specialChar"
                   [class.fa-exclamation-circle]="!passwordValidations.specialChar"></i>
                <p>Password must contain a special character</p>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Confirm Password</label>
            <input type="password"
                   class="form-control form-control-lg"
                   [(ngModel)]="passwordConfirmation"
                   #passConfirm="ngModel"
                   name="passConfirm"
                   required />
            <div *ngIf="submitted && passConfirm.invalid" class="invalid-feedback">
              <div *ngIf="passConfirm.errors?.['required']">
                <i class="fas fa-exclamation-circle"></i>
                <p>Password Confirmation is required</p>
              </div>
            </div>
          </div>

          <div class="button-group" style="width: 100%">
            <button type="submit" class="submit-btn">Reset Password</button>
          </div>
        </div>


        <div class="form-footer">
          <div>
            <p><small>Copy &copy;2024 H.A.S.S Ear Institute</small></p>
            <small><a style="margin-right: 10px">Term of Service</a> | <a style="margin-left: 10px">Privacy Policy</a></small>
          </div>

        </div>
      </div>

    </form>

  </div>
</div>
